import { useTheme } from "@hooks";
import { ProgressBarProps } from "./types";

export const ProgressBar = ({
  progress = 0,
  barHeight = 5,
  borderRadius = 8,
  color: colorProp,
  backgroundColor: backgroundColorProp,
  style,
}: ProgressBarProps) => {
  const { theme } = useTheme();

  const color = colorProp ?? theme.accounts.item.progress.default;
  const backgroundColor = backgroundColorProp ?? theme.accounts.item.progress.background;

  const progressWidth = `${progress * 100}%`;

  return (
    <div
      style={{
        borderRadius,
        height: barHeight,
        width: "100%",
        backgroundColor,
        overflow: "hidden",
        ...style,
      }}
    >
      <div
        style={{
          width: progressWidth,
          height: "100%",
          borderRadius,
          backgroundColor: color,
        }}
      />
    </div>
  );
};
